import React from 'react';
import s from './Characteristics.module.css';
import Ribbon from '../../Ribbon/Ribbon';
import List from './List';

function Characteristics({ data, svg }) {
  return (
    <section className={s.section} id="characteristics">
      <h2 className={s.header}>Характеристики</h2>
      <ul className={s.listMain}>
        <li id={data[0].type}>
          <List data={data[0].characteristics} type={data[0].type} svg={svg} />
        </li>
        <li id={data[1].type}>
          <List data={data[1].characteristics} type={data[1].type} svg={svg} />
        </li>
        <li id={data[2].type}>
          <List data={data[2].characteristics} type={data[2].type} svg={svg} />
        </li>
        {data[3] && data[3].characteristics.length > 0 && (
          <li id={data[3].type}>
            <List
              data={data[3].characteristics}
              type={data[3].type}
              svg={svg}
            />
          </li>
        )}
      </ul>
      <div className={s.ribbon}>
        <Ribbon />
      </div>
    </section>
  );
}

export default Characteristics;
